import { map } from 'rxjs/operators';
import { AppConstant } from './../config/app.constant';
import { BehaviorSubject, fromEvent, merge, Observable, Observer } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStateProvider {
  sideNav = new BehaviorSubject<{
    index: string;
    link: string;
    name: string;
    sub?: any[];
  }>(undefined);
  isLoggedIn = new BehaviorSubject<boolean>(
    localStorage.getItem(AppConstant.localStorage.token) !== undefined &&
    localStorage.getItem(AppConstant.localStorage.token) !== null &&
    localStorage.getItem(AppConstant.localStorage.token) !== '' &&
    localStorage.getItem(AppConstant.localStorage.token) !== 'token'
      ? true
      : false
  );
  toastMessage = new BehaviorSubject<string>(undefined);
  notificationState = new BehaviorSubject(null);
  constructor() {}

  setSideNavState(sideNav: {
    index: string;
    link: string;
    name: string;
    sub?: any[];
  }): void {
    this.sideNav.next(sideNav);
  }

  getSetNavState(): Observable<{
    index: string;
    link: string;
    name: string;
    sub?: any[];
  }> {
    return this.sideNav.asObservable();
  }

  setLoginStatus(status: boolean): void {
    this.isLoggedIn.next(status);
  }

  getLoginStatus(): Observable<boolean> {
    return this.isLoggedIn.asObservable();
  }

  lastRefreshedTime() {
    let hours = new Date().getHours();
    let minutes = new Date().getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const min = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + min + ' ' + ampm;
    return strTime;
  }

  showToast(message) {
    this.toastMessage.next(message);
  }

  toggleNotificationsDrawer(isOpened) {
    // console.log('toggled with ', isOpened);

    this.notificationState.next(isOpened);
  }

  getNotificationDrawerState() {
    // console.log('calling subscribe');

    return this.notificationState.asObservable();
  }

  isMobileDevice() {
    return typeof window.orientation !== 'undefined';
  }

  checkOnlineStatus() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable<boolean>((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

  checkOS() {
    var userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
      if (safari) {
        //browser
        // console.log("iOS browser");
      } else if (!safari) {
        //webview
        // console.log("iOS webview");
      }
      return 'iOS';
    } else {
      //not iOS
      // console.log("android browser");
      return 'Android';
    }
  }
}
